import { createUseStyles } from 'react-jss';
export default createUseStyles({
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 200,
    padding: '8px 0',
    overflowX: 'hidden'
  }
});